export const PieChart = `PieChart`;
export const ThreeDPieChart = `ThreeDPieChart`;
export const ColumnWithRotatedLabels = `ColumnWithRotatedLabels`;
export const ColumnWithCategsAndLabels = `ColumnWithCategsAndLabels`;
export const CombinationChart = `CombinationChart`;
export const Table = `Table`;
export const Gauge = `Gauge`;
export const HeatMap = `HeatMap`;
export const HTML = `HTML`;
export const ColumnRange = `ColumnRange`;
export const Calendar = `Calendar`;
export const ResourceView = `ResourceView`;
export const Report = `Report`;
export const BasicAreaChart = `BasicAreaChart`;
export const StackedAndGroupedColumn = "StackedAndGroupedColumn";